import { useSettings } from '@/contexts/SettingsContext';
import { useTranslations } from '@/hooks/useTranslations';

export function useTranslatedLegacySettings() {
    const { t } = useTranslations();
    const base = useSettings();
    const { legacy } = base;

    const translatedLegacy = {
        ...legacy,
        LEAD_STATUS_OPTIONS: legacy.LEAD_STATUS_OPTIONS.map((status) => ({
            ...status,
            label: t(`settings.lead_statuses.${status.value}`, status.label),
        })),
        LEAD_PRIORITY_OPTIONS: legacy.LEAD_PRIORITY_OPTIONS.map((priority) => ({
            ...priority,
            label: t(`settings.lead_priorities.${priority.value}`, priority.label),
        })),
        COMPANY_PRIORITY_OPTIONS: legacy.COMPANY_PRIORITY_OPTIONS.map((priority) => ({
            ...priority,
            label: t(`settings.company_priorities.${priority.value}`, priority.label),
        })),
        PROJECT_STATUS_OPTIONS: legacy.PROJECT_STATUS_OPTIONS.map((status) => ({
            ...status,
            label: t(`settings.project_statuses.${status.value}`, status.label),
        })),
        PROJECT_TASK_STATUS_OPTIONS: legacy.PROJECT_TASK_STATUS_OPTIONS.map((status) => ({
            ...status,
            label: t(`settings.project_task_statuses.${status.value}`, status.label),
        })),
        PROJECT_TASK_TYPE_OPTIONS: legacy.PROJECT_TASK_TYPE_OPTIONS.map((type) => ({
            ...type,
            label: t(`settings.project_task_types.${type.value}`, type.label),
        })),
        PROJECT_COUNTRY_TYPE_OPTIONS: legacy.PROJECT_COUNTRY_TYPE_OPTIONS.map((type) => ({
            ...type,
            label: t(`settings.project_country_types.${type.value}`, type.label),
        })),
        WORK_ORDER_STATUS_OPTIONS: legacy.WORK_ORDER_STATUS_OPTIONS.map((status) => ({
            ...status,
            label: t(`settings.work_order_statuses.${status.value}`, status.label),
        })),
        WORK_ORDER_PRIORITY_OPTIONS: legacy.WORK_ORDER_PRIORITY_OPTIONS.map((priority) => ({
            ...priority,
            label: t(`settings.work_order_priorities.${priority.value}`, priority.label),
        })),
        WORK_ORDER_TYPE_OPTIONS: legacy.WORK_ORDER_TYPE_OPTIONS.map((type) => ({
            ...type,
            label: t(`settings.work_order_types.${type.value}`, type.label),
        })),
        TASK_TYPE_OPTIONS: legacy.TASK_TYPE_OPTIONS.map((type) => ({
            ...type,
            label: t(`settings.task_types.${type.value}`, type.label),
        })),
        COMPANY_CATEGORY_OPTIONS: legacy.COMPANY_CATEGORY_OPTIONS.map((category) => ({
            ...category,
            label: t(`settings.company_categories.${category.value}`, category.label),
        })),
        COMPANY_TYPE_OPTIONS: legacy.COMPANY_TYPE_OPTIONS.map((type) => ({
            ...type,
            label: t(`settings.company_types.${type.value}`, type.label),
        })),
        LEAD_SOURCE_OPTIONS: legacy.LEAD_SOURCE_OPTIONS.map((source) => ({
            ...source,
            label: t(`settings.lead_sources.${source.value}`, source.label),
        })),
        COST_LINE_TYPE_OPTIONS: legacy.COST_LINE_TYPE_OPTIONS.map((type) => ({
            ...type,
            label: t(`settings.cost_line_types.${type.value}`, type.label),
        })),
        PROJECT_COST_LINE_TYPE_OPTIONS: legacy.PROJECT_COST_LINE_TYPE_OPTIONS.map((type) => ({
            ...type,
            label: t(`settings.project_cost_line_types.${type.value}`, type.label),
        })),
        WORK_ORDER_COST_LINE_TYPE_OPTIONS: legacy.WORK_ORDER_COST_LINE_TYPE_OPTIONS.map((type) => ({
            ...type,
            label: t(`settings.work_order_cost_line_types.${type.value}`, type.label),
        })),
    };

    return {
        ...base,
        legacy: translatedLegacy,
    };
}
